import { render, staticRenderFns } from "./vsds-filter.vue?vue&type=template&id=177f0eae&"
import script from "./vsds-filter.vue?vue&type=script&lang=js&"
export * from "./vsds-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports